'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { embroideryProductKeyAtom, showEmbroideryOnDetailPageAtom } from '@/store/atoms';
import { getEmbroideryPrice } from '@/utility/embroideryHelpers';
import { Locale } from '@/utility/locale';
type UseEmbroideryTrackedPriceParams = {
  basePrice: number;
  productTypeId: string;
  locale: Locale;
  partnerId: string;
  sellable: Pick<Sellable, 'printAreas'>;
};
export const useEmbroideryPrice = t0 => {
  const $ = _c(9);
  const {
    basePrice,
    productTypeId,
    locale,
    partnerId,
    sellable
  } = t0;
  const showEmbroidery = useAtomValue(showEmbroideryOnDetailPageAtom);
  const embroideryProductKey = useAtomValue(embroideryProductKeyAtom);
  const [displayPrice, setDisplayPrice] = useState(basePrice);
  let t1;
  let t2;
  if ($[0] !== basePrice || $[1] !== embroideryProductKey || $[2] !== locale || $[3] !== partnerId || $[4] !== productTypeId || $[5] !== sellable || $[6] !== showEmbroidery) {
    t1 = () => {
      let isCancelled = false;
      const updatePrice = async () => {
        if (!showEmbroidery || !embroideryProductKey) {
          setDisplayPrice(basePrice);
          return;
        }
        try {
          const {
            price
          } = await getEmbroideryPrice({
            locale,
            partnerId,
            productTypeId,
            sellable
          });
          if (!isCancelled) {
            setDisplayPrice(price);
          }
        } catch {
          if (!isCancelled) {
            setDisplayPrice(basePrice);
          }
        }
      };
      updatePrice();
      return () => {
        isCancelled = true;
      };
    };
    t2 = [showEmbroidery, embroideryProductKey, basePrice, locale, partnerId, productTypeId, sellable];
    $[0] = basePrice;
    $[1] = embroideryProductKey;
    $[2] = locale;
    $[3] = partnerId;
    $[4] = productTypeId;
    $[5] = sellable;
    $[6] = showEmbroidery;
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  useEffect(t1, t2);
  return displayPrice;
};